export const getRollList = (entityList, hList, merchant) => {
    return [
        {
            name: 'aggregator',
            label: 'Aggregator',
            popupTitle: 'Add Aggregator',
            selected: hList.agr || null,
            props: {
                input: false,
                data: entityList.aggregator || [],
                label: 'Select Aggregator',
                labelField: 'name',
                valueField: 'entityCode',
                defaultSelected: '',
            },
            type: 'AGGREGATOR',
        },
        {
            name: 'franchise',
            label: 'Franchise',
            popupTitle: 'Add Franchise',
            selected: hList.fra || null,
            props: {
                input: false,
                data: !hList.agr
                    ? entityList.franchise
                    : hList.fraList || entityList.franchise || [],
                label: 'Select Franchise',
                labelField: 'name',
                valueField: 'entityCode',
                defaultSelected: '',
            },
            type: 'FRANCHISE',
        },
        {
            name: 'mle',
            label: 'MLE',
            popupTitle: 'Add MLE',
            selected: hList.mle || null,
            props: {
                data:
                    !hList.agr && !hList.fra
                        ? entityList.mle
                        : hList.mleList || entityList.mle || [],
                input: false,
                label: 'Select MLE',
                labelField: 'name',
                valueField: 'entityCode',
                defaultSelected: '',
            },
            type: 'MLE',
        },
        {
            name: 'merchant',
            label: 'Merchant',
            popupTitle: 'Add Merchant',
            selected: hList.mid || null,
            props: {
                data:
                    !hList.agr && !hList.fra && !hList.mle
                        ? merchant && entityList.merchant
                            ? [
                                ...entityList.merchant.filter(
                                    item =>
                                        item.entityCode !==
                                          merchant.entityCode
                                ),
                                merchant,
                            ]
                            : entityList.merchant
                        : hList.midList || entityList.merchant || [],
                input: false,
                label: 'Select Merchant',
                labelField: 'name',
                valueField: 'entityCode',
                defaultSelected: '',
            },
            type: 'MERCHANT',
        },
    ];
};

export const maskAccountNumber = accountNumber => {
    if (!accountNumber) {
        return '';
    }
    return (
        accountNumber.slice(0, -4).replace(/\d/g, 'X') + accountNumber.slice(-4)
    );
};
